import { render, staticRenderFns } from "./ActivateUsers.vue?vue&type=template&id=5063fec2&scoped=true&"
import script from "./ActivateUsers.ts?vue&type=script&lang=ts&"
export * from "./ActivateUsers.ts?vue&type=script&lang=ts&"
import style0 from "./ActivateUsers.scss?vue&type=style&index=0&id=5063fec2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5063fec2",
  null
  
)

export default component.exports